"use client";

import { formatUSDBalance } from "@/hooks/useSmartAccountBalances";

interface PortfolioHeaderProps {
  email?: string | null;
  totalValue: number;
  hasSmartAccount: boolean;
}

export function PortfolioHeader({ email, totalValue, hasSmartAccount }: PortfolioHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      {/* Left: title + email */}
      <div>
        <h1
          style={{
            fontFamily: '"Instrument Serif", Georgia, serif',
            fontStyle: "italic",
            fontSize: 36,
            color: "#f0ece4",
            letterSpacing: "-0.02em",
            fontWeight: 400,
            lineHeight: 1.1,
            margin: 0,
          }}
        >
          Portfolio
        </h1>
        <p className="text-[12px] mt-1" style={{ color: "var(--text-secondary)" }}>
          {email ?? "Welcome back"}
        </p>
      </div>

      {/* Right: portfolio value — only when smart account exists */}
      {hasSmartAccount && (
        <div className="text-right flex-shrink-0">
          <p
            className="text-[10px] tracking-[0.08em] uppercase font-medium mb-0.5"
            style={{ color: "var(--text-secondary)" }}
          >
            Portfolio Value
          </p>
          <p
            className="font-serif font-normal leading-none"
            style={{ fontSize: "2rem", color: "var(--text-primary)" }}
          >
            {formatUSDBalance(totalValue)}
          </p>
          <p className="text-[11px] mt-1" style={{ color: "var(--text-tertiary)" }}>
            —
          </p>
        </div>
      )}
    </div>
  );
}
